export const repairAnalysisInfo = {
    headline: 'Votre fichier a été réparé.',
    numberOfFlippedPolygons: 'Normales inversées :',
    numberOfRemovedFlatOpenShells: 'Surfaces non connectées supprimées :',
    numberOfClosedOpenLoops: 'Trous fermés :',
    numberOfMergedVertexPairs: 'Paires de vertex unies :',
    repairPictureHeadline: 'Réparations effectuées :',
    repairPictureControls:
        'Veuillez examiner tous les côtés du modèle pour vérifier toutes les réparations effectuées (les changements importants sont soulignés en rouge).',
    fileIsReadyForPrinting:
        'Le fichier peut désormais être traité en impression 3D. Vous pouvez suivre les modifications ici ou télécharger le fichier pour le visualiser.',
    downloadFile: 'Télécharger',
    continue: 'Fermer',
};
